// extracted by mini-css-extract-plugin
export default {"container":"yourmessage_container__ROz-T","outer":"yourmessage_outer__ea+pO","fileContainer":"yourmessage_fileContainer__tyFBO"};